import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { IThreeDotsMenuOption } from '../../interfaces/three-dots-menu-option.interface';

@Component({
  selector: 'app-three-dots-menu',
  templateUrl: './three-dots-menu.component.html',
  styleUrls: ['./three-dots-menu.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class ThreeDotsMenuComponent {

  @Input() options: IThreeDotsMenuOption[];

  @Output() selected: EventEmitter<IThreeDotsMenuOption> = new EventEmitter();



  /**
   *
   */
  constructor() {
  
    
  }
}

